/**
 * Generated by orval v8.6.2 🍺
 * Do not edit manually.
 * device-mockup-tool-server
 * OpenAPI spec version: 1.10.0
 */
import type {DeviceDetailResponse, DeviceListItem, ListDevicesParams} from '../../model'

import {customFetch} from '../../../mutator/customFetch'

/**
 * Lists all available device presets
 */
export type listDevicesResponse200 = {
  data: DeviceListItem[]
  status: 200
}

export type listDevicesResponseSuccess = listDevicesResponse200 & {
  headers: Headers
}
export type listDevicesResponse = listDevicesResponseSuccess

export const getListDevicesUrl = (params?: ListDevicesParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      if (Array.isArray(value)) {
        value.forEach((v) => normalizedParams.append(key, v === null ? 'null' : String(v)))
      } else {
        normalizedParams.append(key, value === null ? 'null' : value.toString())
      }
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0 ? `/devices?${stringifiedParams}` : `/devices`
}

export const listDevices = async (params?: ListDevicesParams, options?: RequestInit): Promise<listDevicesResponse> => {
  return customFetch<listDevicesResponse>(getListDevicesUrl(params), {
    ...options,
    method: 'GET',
  })
}

/**
 * Returns a single device preset by slug
 */
export type getDeviceResponse200 = {
  data: DeviceDetailResponse
  status: 200
}

export type getDeviceResponseSuccess = getDeviceResponse200 & {
  headers: Headers
}
export type getDeviceResponse = getDeviceResponseSuccess

export const getGetDeviceUrl = (slug: string) => {
  return `/devices/${slug}`
}

export const getDevice = async (slug: string, options?: RequestInit): Promise<getDeviceResponse> => {
  return customFetch<getDeviceResponse>(getGetDeviceUrl(slug), {
    ...options,
    method: 'GET',
  })
}

/**
 * Increments usage counter for a device
 */
export type trackDeviceUsageResponse204 = {
  data: void
  status: 204
}

export type trackDeviceUsageResponseSuccess = trackDeviceUsageResponse204 & {
  headers: Headers
}
export type trackDeviceUsageResponse = trackDeviceUsageResponseSuccess

export const getTrackDeviceUsageUrl = (slug: string) => {
  return `/devices/${slug}/use`
}

export const trackDeviceUsage = async (slug: string, options?: RequestInit): Promise<trackDeviceUsageResponse> => {
  return customFetch<trackDeviceUsageResponse>(getTrackDeviceUsageUrl(slug), {
    ...options,
    method: 'POST',
  })
}
